import { createStyles } from '@material-ui/core/styles';
const styles = (theme) => createStyles({
    popoverContainer: {
        display: 'flex',
        flexDirection: 'column',
        background: theme.color.grey.dark,
        borderRadius: theme.common.borderRadius.default,
        '& Button': {
            borderRadius: 1,
            minWidth: 150,
            height: 40,
            color: theme.color.font.light,
            justifyContent: 'flex-start',
            textTransform: 'none',
            fontWeight: theme.font.weight.light,
            '&:hover': {
                backgroundColor: theme.color.grey.darkest,
                fontWeight: theme.font.weight.normal,
            },
        },
    },
    buttonContainer: {
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },
});
export default styles;
//# sourceMappingURL=DataTableSettingsPopoverStyles.js.map